import React, { Component } from "react";
import { Row, Col, Card, Form } from "reactstrap";
import CgnTextbox from "../toolbox/CgnTextbox";
import CgnReactSelect from "../toolbox/CgnReactSelect";
import CgnAlert from "../toolbox/CgnAlert";
import CgnButtonGroup from "../toolbox/CgnButtonGroup";
import CgnLoader from "../toolbox/CgnLoader";
import CgnMessage from "../toolbox/CgnMessage";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import CgnDatePicker from "../toolbox/CgnDatePicker";
import {
  URL,
  
  UserOperationClaimControl, manuelControlStatus} from "../../redux/actions/constants";
import CgnButton from "../toolbox/CgnButton";
import { withRouter } from "react-router-dom";
import { config } from "@fortawesome/fontawesome-svg-core";

class PinPutTestAddUpdate extends Component {
  state = {
    pageTitle: "Pin İtme Testi Ekle",
    pageTitleAdd: "Pin İtme Testi Ekle",
    pageTitleUpdate: "Pin İtme Testi Güncelle",
    pageAddLink: "pin-itme-testi-ekle",
    pageListLink: "pin-itme-testi-listele",
    breadcrumb: [{ text: "Pin İtme Testi", link: "#" }],
    isLoading: false,
    urlSplit: [],
    productArr: [],
    productGuid: "",
    product2Guid: "",
    productArr2: [],
    materialArr: [],
    materialGuid: "",
    materialArr2 :[],
    material2Guid: "",
    workInstructionArr: [],
    pinPutTestProductDto: [],
    pinPutTestDeviceUsedDto: [],
    deviceUsedArr: [],
    deviceUsedGuid: "",
    detectionPersonelGuid: "",
    lastControlPersonelGuid: "",
    lastControlGuid: "",
    pinPutTestDate: "",
    itemNumber: "",
    processDefinitionGuid: "",
    serialNo: "",
    testSerialNo: "",
    workInstructionGuid: "",
    customerGuid: "",
    personelGuid: "",
    productOutGuid: "",
    guid: "",
    cocNo: "",
    status: true,
    isNull: false,
    modalButtonIdx: 0,
    customerArr: [],
    productOutArr: [],
    detectionPersonelArr: [],
    lastControlPersonelArr: [],
    qualityPersonelArr: [],
    qualityPersonelGuid: "",
    processDefinitionArr: [],
    isTrue: false,
    productError: "",
    alertErrorMessage: "",
    workInstructionError: "",
    pinPutTestDateError: "",
    detectionPersonelError: "",
    processDefinitionError: "",
    counter: -1,
    counter1: -1,
    message: "",
    statusChange: "",
    statusChangeError: "",
    buttons: [
      {
        type: "button",
        color: "secondary",
        text: CgnMessage.clearButton,
        onClick: (event) => this.handleClear(event),
        disabled: this.isLoading,
      },
      {
        type: "submit",
        color: "primary",
        text: CgnMessage.saveButton,
        disabled: this.isLoading,
      },
    ],
    productModalPlus: false,
    materialModalPlus: false,
  };

  async componentDidMount() {
    this.setState({
      isLoading: true,
      productModalPlus: await UserOperationClaimControl(1029),
    });
    // 
    var config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    var statusType = 2; // sadece aktif olanları göstermesi için
    axios
      .get(URL + "/workInstructions/getlistsuitabilityform", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: `${item.code}-${item.customerName}`,
          };
        });
        this.setState({
          workInstructionArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
    axios
      .get(URL + "/customers/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          customerArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
    axios
      .get(URL + "/materials/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          materialArr: myArr,
          materialArr2: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
      axios
      .get(URL + "/deviceUseds/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          deviceUsedArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
    axios
      .get(URL + "/processDefinitions/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: item.name,
          };
        });
        this.setState({
          processDefinitionArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
        });
      });
    axios
      .get(URL + "/productOutsSecond/getlistforworkorder", config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: `${item.productOutDate}-${item.customerName}`,
          };
        });
        this.setState({
          productOutArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    axios
      .get(URL + "/products/getlist/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          var label = `${item.code}-${item.name}`;
          if(item.supplierProductCode && item.supplierProductCode !== "") {
            label = `${item.code}-${item.supplierProductCode}-${item.name}`;
          }
          return {
            value: item.guid,
            label: label,
          };
        });
        this.setState({
          productArr: myArr,
          productArr2: myArr
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });
    await axios
      .get(URL + "/members/getmembers/" + statusType, config)
      .then((response) => {
        var myArr = response.data.map(function (item) {
          return {
            value: item.guid,
            label: `${item.firstName} ${item.lastName}`,
          };
        });
        this.setState({
          detectionPersonelArr: myArr,
          qualityPersonelArr: myArr,
          lastControlPersonelArr: myArr,
          personelArr: myArr,
        });
      })
      .catch((error) => {
        this.setState({
          alertErrorMessage: error.response.data,
          isLoading: false,
        });
      });

    let urlSplit = window.location.pathname.split("/");
    this.setState({
      urlSplit: urlSplit,
    });
    if (
      urlSplit.length === 3 &&
      urlSplit[1] === "pin-itme-testi-guncelle"
    ) {
      this.setState({
        guid: urlSplit[urlSplit.length - 1],
        pageTitle: this.state.pageTitleUpdate,
      });
      this.getById(urlSplit[2]);
      axios
        .get(URL + "/pinPutTests/get/" + urlSplit[2], config)
        .then((response) => {
          if (this.state.guid) {
            this.setState({
              guid: response.data.guid,
              productGuid: response.data.productGuid,
              workInstructionGuid: response.data.workInstructionGuid,
              customerGuid: response.data.customerGuid,
              productOutGuid: response.data.productOutGuid,
              personelGuid: response.data.personelGuid,
              serialNo: response.data.serialNo,
              testSerialNo: response.data.testSerialNo,
              workInstructionCode: response.data.workInstructionCode,
              detectionPersonelGuid: response.data.detectionPersonelGuid,
              pinPutTestDeviceUsedDto: response.data.pinPutTestDeviceUsedDto,
              counter: response.data.pinPutTestDeviceUsedDto.length - 1,
              pinPutTestProductDto: response.data.pinPutTestProductDto,
              counter1: response.data.pinPutTestProductDto.length - 1,
              dispatchPiece: response.data.dispatchPiece,
              pinPutTestDate: response.data.pinPutTestDate,
              lastControlPersonelGuid: response.data.lastControlPersonelGuid,
              qualityPersonelGuid: response.data.qualityPersonelGuid,
              isLoading: false
            });
          }
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }
  async componentDidUpdate(previousState) {
    let urlSplit = window.location.pathname.split("/");
    if (
      urlSplit.length === 2 &&
      this.state.pageTitle !== this.state.pageTitleAdd
    ) {
      this.setState({
        pageTitle: this.state.pageTitleAdd,
        urlSplit: urlSplit,
        serialNo: "",
        workInstructionGuid: "",
        pinPutTestDate: "",
        pinPutTestDeviceUsedDto: [],
        pinPutTestProductDto: [],
        detectionPersonelGuid: "",
        dispatchPiece: "",
        testSerialNo: "",
        status: true,
        counter: -1,
        counter1: -1,
        isTrue: false,
      });
    }

    if (this.state.status === undefined) {
      this.setState({
        status: true,
      });
    }
  }

  getById(guid) {
    this.setState({
      isLoading: true,
      guid: guid,
    });
  }

  handleClear = (event) => {
    this.clearPage();
  };

  async clearPage() {
    this.setState({
      serialNo: "",
      workInstructionGuid: "",
      pinPutTestDate: "",
      pinPutTestDeviceUsedDto: [],
      pinPutTestProductDto: [],
      detectionPersonelGuid: "",
      dispatchPiece: "",
      testSerialNo: "",
      status: true,
      counter: -1,
      counter1: -1,
      isTrue: false,
    });
  }

  handleProductSelectChange(option) {
    if (option) {
      this.setState({
        productGuid: option.value,
        productError: "",
        alertErrorMessage: "",
      });
    } else {
      this.setState({
        productGuid: "",
        productError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  }

  handlePinProductSelectChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].productGuid = option.value;
      pinPutTestProductDto[idx].productError = "";
    } else {
      pinPutTestProductDto[idx].productGuid = "";
      pinPutTestProductDto[idx].productError = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handlePin2ProductSelectChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].product2Guid = option.value;
      pinPutTestProductDto[idx].product2Error = "";
    } else {
      pinPutTestProductDto[idx].product2Guid = "";
      pinPutTestProductDto[idx].product2Error = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handlePinMaterialSelectChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].materialGuid = option.value;
      pinPutTestProductDto[idx].materialError = "";
    } else {
      pinPutTestProductDto[idx].materialGuid = "";
      pinPutTestProductDto[idx].materialError = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handlePin2MaterialSelectChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].material2Guid = option.value;
      pinPutTestProductDto[idx].material2Error = "";
    } else {
      pinPutTestProductDto[idx].material2Guid = "";
      pinPutTestProductDto[idx].material2Error = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  async handleWorkInstructionSelectChange(option){
    if(option){
     this.setState({
       workInstructionGuid: option.value,
       workInstructionError: "",
       isLoading: true
     });
     // 
     var config = {
       headers: {
         Authorization: "Bearer " + localStorage.getItem("token"),
       },
     };
     axios 
     .get(URL + "/workInstructions/get/" + option.value, config)    
     .then((response) => {
       if(response.data.guid){
         this.setState({
            productGuid: response.data.productGuid,
            productOutGuid: response.data.productOutGuid,
            customerGuid: response.data.customerGuid,
            personelGuid: response.data.personelGuid,
            workInstructionCode: response.data.code,
            lastControlPersonelGuid: response.data.lastControlPersonelGuid,
            qualityPersonelGuid: response.data.qualityPersonelGuid,
            isLoading: false
         });
       }
     })
    }
    else{
     this.setState({
       workInstructionGuid: "",
       productGuid: "",
       customerGuid: "",
       personelGuid: "",
       productOutGuid: "",
       workInstructionCode: "",
       lastControlPersonelGuid: "",
       qualityPersonelGuid: "",
       workInstructionError: CgnMessage.alertErrorMessage,
     });
    }
   }
 

  handleDispatchPieceTextBoxChange(e) {
    this.setState({
      dispatchPiece: parseFloat(e.target.value),
      dispatchPieceError: "",
      alertErrorMessage: "",
    });
  }

  handleSerialNoTextBoxChange(e) {
    this.setState({
      serialNo: e.target.value,
      serialNoError: "",
      alertErrorMessage: "",
    });
  }

  handleTestSerialNoTextBoxChange(e) {
    this.setState({
      testSerialNo: e.target.value,
      testSerialNoError: "",
      alertErrorMessage: "",
    });
  }

  handleStatusSelectChange(status) {
    this.setState({ status: status.value });
  }

  handlePinPutTestDateChange(pinPutTestDate) {
    if (pinPutTestDate) {
      this.setState({
        pinPutTestDate: pinPutTestDate,
        pinPutTestDateError: "",
      });
    } else {
      this.setState({
        pinPutTestDate: "",
        pinPutTestDateError: CgnMessage.alertErrorMessage,
      });
    }
  }

  handleDetectionPersonelChange(option) {
    if (option) {
      this.setState({
        detectionPersonelGuid: option.value,
        detectionPersonelError: "",
      });
    } else {
      this.setState({
        detectionPersonelGuid: "",
        detectionPersonelError: CgnMessage.alertErrorMessage,
      });
    }
  }


  handleChange = async (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleChange2 = tags => (event) => {
    const { name, value } = event.target;
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    var idx = tags;

    pinPutTestProductDto[idx][name] = value;
    this.setState({
      pinPutTestProductDto: pinPutTestProductDto,
    });
  };

  handleResultStatusChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].resultChange = option.value;
      pinPutTestProductDto[idx].resultChangeError = "";
    } else {
      pinPutTestProductDto[idx].resultChange = null;
      pinPutTestProductDto[idx].resultChangeError = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handleProductChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].productGuid = option.value;
      pinPutTestProductDto[idx].productError = "";
    } else {
      pinPutTestProductDto[idx].productGuid = "";
      pinPutTestProductDto[idx].productError = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handleProduct2Change(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].product2Guid = option.value;
      pinPutTestProductDto[idx].product2Error = "";
    } else {
      pinPutTestProductDto[idx].product2Guid = "";
      pinPutTestProductDto[idx].product2Error = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handleMaterialChange(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].materialGuid = option.value;
      pinPutTestProductDto[idx].materialError = "";
    } else {
      pinPutTestProductDto[idx].materialGuid = "";
      pinPutTestProductDto[idx].materialError = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handleMaterial2Change(option, idx) {
    let pinPutTestProductDto = this.state.pinPutTestProductDto;
    if (option) {
      pinPutTestProductDto[idx].material2Guid = option.value;
      pinPutTestProductDto[idx].material2Error = "";
    } else {
      pinPutTestProductDto[idx].material2Guid = "";
      pinPutTestProductDto[idx].material2Error = "";
    }

    this.setState({ pinPutTestProductDto: pinPutTestProductDto });
  }

  handleDeviceUsedSelectChange(option, idx) {
    let pinPutTestDeviceUsedDto = this.state.pinPutTestDeviceUsedDto;
    if (option) {
      pinPutTestDeviceUsedDto[idx].deviceUsedGuid = option.value;
      pinPutTestDeviceUsedDto[idx].deviceUsedError = "";
    } else {
      pinPutTestDeviceUsedDto[idx].deviceUsedGuid = "";
      pinPutTestDeviceUsedDto[idx].deviceUsedError = "";
    }

    this.setState({ pinPutTestDeviceUsedDto: pinPutTestDeviceUsedDto });
  }

  handleProductAdd = async () => {
    let array = this.state.pinPutTestProductDto;
    await array.push({
      productGuid: "",
      product2Guid: "",
      materialGuid: "",
      material2Guid: "",
      power: "",
      description: "",
      resultChange: "",
    });
    await this.setState({
      counter1: this.state.counter1 + 1,
    });
    if (array[this.state.counter1].resultChange) {
      return array[this.state.counter1].resultChangeError === "";
    }
    if (array[this.state.counter1].resultChange === "") {
      this.setState({
        isNull: true,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.setState({ pinPutTestProductDto: array });
  };

  handleDeviceUsedAdd = async () => {
    let array = this.state.pinPutTestDeviceUsedDto;
    await array.push({
      deviceUsedGuid: "",
    });
    await this.setState({
      counter: this.state.counter + 1,
    });
    if (array[this.state.counter].deviceUsedGuid) {
      return array[this.state.counter].deviceUsedGuidError === "";
    }
    if (array[this.state.counter].deviceUsedGuid === "") {
      this.setState({
        isNull: true,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    this.setState({ pinPutTestDeviceUsedDto: array });
  };

  async handleProductRemove(idx) {
    let someArray = this.state.pinPutTestProductDto;
    someArray.splice(idx, 1);
    await this.setState({
      pinPutTestProductDto: someArray,
      counter1: this.state.counter1 - 1,
    });
    if (idx === 0) {
      this.setState({
        alertErrorMessage: "",
      });
    }
  }

  async handleDeviceUsedRemove(idx) {
    let someArray = this.state.pinPutTestDeviceUsedDto;
    someArray.splice(idx, 1);
    await this.setState({
      pinPutTestDeviceUsedDto: someArray,
      counter: this.state.counter - 1,
    });
    if (idx === 0) {
      this.setState({
        alertErrorMessage: "",
      });
    }
  }

  handleSave = async (event) => {
    event.preventDefault();
    this.setState({
      alertErrorMessage: "",
      workInstructionErrorError: "",
      pinPutTestDateError: "",
    });
    if (this.state.workInstructionGuid === "") {
      this.setState({
        workInstructionError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.pinPutTestDate === "") {
      this.setState({
        pinPutTestDateError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    if (this.state.detectionPersonelGuid === "") {
      this.setState({
        detectionPersonelError: CgnMessage.textErrorMessage,
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
    
    var control = true;
    if (
      this.state.pinPutTestDeviceUsedDto !== null &&
      this.state.pinPutTestDeviceUsedDto.length > 0
    ) {
      this.state.pinPutTestDeviceUsedDto.forEach((element) => {
        if (element.deviceUsedGuid === "" || element.deviceUsedGuid === null) {
          control = false;
        }
      });
    }

    var control2 = true;
    if(this.state.pinPutTestProductDto !== null &&
      this.state.pinPutTestProductDto.length > 0){
        this.state.pinPutTestProductDto.forEach((element) => {
          if (element.productGuid === "") {
            control2 = false;
          }
          if (element.materialGuid === "") {
            control2 = false;
          }
          if (element.product2Guid === "") {
            control2 = false;
          }
          if (element.material2Guid === "") {
            control2 = false;
          }
          if (element.resultChange === "" || element.resultChange === null) {
            control2 = false;
          }
        });
    }

    if (
      this.state.workInstructionGuid !== "" &&
      this.state.pinPutTestDate !== "" &&
      this.state.detectionPersonelGuid !== "" &&
      control === true &&
      control2 === true
    ) {
      this.setState({
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };    

      var myObj = {
        workInstructionGuid: this.state.workInstructionGuid,
        detectionPersonelGuid: this.state.detectionPersonelGuid,
        pinPutTestDate: this.state.pinPutTestDate,
        serialNo: this.state.serialNo,
        testSerialNo: this.state.testSerialNo,
        dispatchPiece: this.state.dispatchPiece === "" ? 0 : parseFloat(this.state.dispatchPiece),
        pinPutTestProductDto: this.state.pinPutTestProductDto,
        pinPutTestDeviceUsedDto: this.state.pinPutTestDeviceUsedDto,
      };
      var URLParam = "/pinPutTests/add";
      if (
        this.state.guid &&
        this.state.urlSplit.length !== 2 &&
        this.state.urlSplit[1] === "pin-itme-testi-guncelle"
      ) {
        URLParam = "/pinPutTests/update";
        myObj = {
          guid: this.state.guid,
          workInstructionGuid: this.state.workInstructionGuid,
          detectionPersonelGuid: this.state.detectionPersonelGuid,
          pinPutTestDate: this.state.pinPutTestDate,
          serialNo: this.state.serialNo,
          testSerialNo: this.state.testSerialNo,
          dispatchPiece: this.state.dispatchPiece === "" ? 0 : parseFloat(this.state.dispatchPiece),
          pinPutTestProductDto: this.state.pinPutTestProductDto,
          pinPutTestDeviceUsedDto: this.state.pinPutTestDeviceUsedDto,
        };
      }
      axios
        .post(URL + URLParam, myObj, config)
        .then(() => {
          setTimeout(() => {
            if (this.state.urlSplit[1] === "pin-itme-testi-ekle") {
              window.location.reload();
            }
            if (
              this.state.guid &&
              this.state.urlSplit[1] === "pin-itme-testi-guncelle"
            ) {
              window.location.href = "/pin-itme-testi-listele";
            }
          }, 1500);
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    } else {
      this.setState({
        alertErrorMessage: CgnMessage.alertErrorMessage,
      });
    }
  };

  render() {
    return (
      <>
        {(this.state.urlSplit[1] === "pin-itme-testi-ekle" ||
          this.state.urlSplit[1] === "pin-itme-testi-guncelle") && (
          <ContentTop
            breadcrumb={this.state.breadcrumb}
            title={this.state.pageTitle}
            addLink={"/" + this.state.pageAddLink}
            listLink={"/" + this.state.pageListLink}
          />
        )}
        <Row>
          <Col>
            <Form onSubmit={this.handleSave}>
              <Card body>
                <CgnLoader visibled={this.state.isLoading} />
                <Row>
                  <Col lg="4">
                    <CgnDatePicker
                      name="pinPutTestDate"
                      label="Tarih [*]"
                      selected={
                        this.state.pinPutTestDate &&
                        this.state.pinPutTestDate
                          .toString()
                          .indexOf("/") > 0
                          ? new Date(
                              this.state.pinPutTestDate.split("/")[2] +
                                "-" +
                                this.state.pinPutTestDate.split("/")[1] +
                                "-" +
                                this.state.pinPutTestDate.split("/")[0]
                            )
                          : this.state.pinPutTestDate
                      }
                      onChange={(pinPutTestDate) =>
                        this.handlePinPutTestDateChange(
                          pinPutTestDate
                        )
                      }
                      error={this.state.pinPutTestDateError}
                      maxDate={new Date(2100, 1, 1)}
                      minDate={new Date(1900, 1, 1)}
                      placeholder="GG/AA/YYYY"
                      autoComplete="off"
                    />
                  </Col>
                  <Col lg="4">
                    <CgnTextbox
                      type="text"
                      name="workInstructionCode"
                      label="İş Emri Numarası [*]"
                      value={this.state.workInstructionCode}
                      placeHolder="Lütfen iş emri no girin..."
                      maxLength="100"
                      autoComplete="off"
                      onChange={this.handleChange}
                      error={this.state.workInstructionCodeError}
                      readOnly={true}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnReactSelect
                      name="workInstructionGuid"
                      label="İş Emri [*]"
                      placeholder="Lütfen iş emri girin..."
                      selectValue={this.state.workInstructionGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleWorkInstructionSelectChange(option)
                      }
                      options={this.state.workInstructionArr}
                      error={this.state.workInstructionError}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="4">
                    <CgnReactSelect
                      name="personelGuid"
                      label="Personel [*]"
                      placeholder="Personel seçiniz..."
                      selectValue={this.state.personelGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handlePersonelSelectChange(option)
                      }
                      options={this.state.personelArr}
                      error={this.state.personelError}
                      disabled={true}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnReactSelect
                      name="customerGuid"
                      label="Müşteri [*]"
                      placeholder="Müşteri seçiniz..."
                      selectValue={this.state.customerGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleProductSelectChange(option)
                      }
                      options={this.state.customerArr}
                      error={this.state.customerError}
                      disabled={true}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnReactSelect
                      name="qualityPersonelGuid"
                      label="Kalite Personel [*]"
                      placeholder="Kalite Personeli seçiniz..."
                      selectValue={this.state.qualityPersonelGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleQualityPersonelSelectChange(option)
                      }
                      options={this.state.qualityPersonelArr}
                      error={this.state.qualityPersonelError}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg="4">
                    <CgnReactSelect
                      name="lastControlPersonelGuid"
                      label="Son Kontrolü Yapan Personel [*]"
                      placeholder="Son kontrolü yapan personeli seçiniz..."
                      selectValue={this.state.lastControlPersonelGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleLastControlPersonelSelectChange(option)
                      }
                      options={this.state.lastControlPersonelArr}
                      error={this.state.lastControlPersonelError}
                      disabled={true}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnReactSelect
                      name="detectionPersonelGuid"
                      label="Tespiti Yapan Personel [*]"
                      placeholder="Tespiti yapan personeli seçiniz..."
                      selectValue={this.state.detectionPersonelGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleDetectionPersonelChange(option)
                      }
                      options={this.state.detectionPersonelArr}
                      error={this.state.detectionPersonelError}
                    />
                  </Col>
                  <Col lg="4">
                    <CgnReactSelect
                      name="productOutGuid"
                      label="Satış [*]"
                      placeholder="Satış seçiniz..."
                      selectValue={this.state.productOutGuid}
                      isMulti={false}
                      isClearable={true}
                      onChange={(option) =>
                        this.handleProductSelectChange(option)
                      }
                      options={this.state.productOutArr}
                      error={this.state.customerError}
                      disabled={true}
                    />
                  </Col>              
                </Row>
                <Row>
                <Col lg="4">
                        <CgnReactSelect
                          name="productGuid"
                          label="Ürün [*]"
                          placeholder="Ürün seçiniz..."
                          selectValue={this.state.productGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleProductSelectChange(option)
                          }
                          options={this.state.productArr}
                          error={this.state.productError}
                          disabled={true}
                        />                  
                  </Col>
                  <Col lg="4">
                  <CgnTextbox
                      type="number"
                      name="dispatchPiece"
                      label="Sevk Edilecek Ürün Miktarı"
                      value={this.state.dispatchPiece}
                      placeHolder="Lütfen sevk edilecek ürün miktarı girin..."
                      autoComplete="off"
                      onChange={(e) => this.handleDispatchPieceTextBoxChange(e)}
                      step="0.1"
                    />
                  </Col>
                  <Col lg="4">
                  <CgnTextbox
                      type="text"
                      name="serialNo"
                      label="Seri Numarası"
                      value={this.state.serialNo}
                      placeHolder="Lütfen seri numarası girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>

                <Row>                               
                  <Col lg="12">
                    <CgnTextbox
                      type="text"
                      name="testSerialNo"
                      label="Test Edilen Cihazlar Seri No"
                      value={this.state.testSerialNo}
                      placeHolder="Lütfen test edilen cihazlar seri no girin..."
                      autoComplete="off"
                      onChange={this.handleChange}
                    />
                  </Col>
                </Row>

                {this.state.pinPutTestDeviceUsedDto.map(
                  (pinPutTestDeviceUsedDto, idx) => (
                    <Row>
                      <Col lg="11" className="pl-0">
                      <CgnReactSelect
                          name="deviceUsedGuid"
                          label="Kullanılan Cihaz [*]"
                          placeholder="Kullanılan cihaz seçiniz..."
                          selectValue={pinPutTestDeviceUsedDto.deviceUsedGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleDeviceUsedSelectChange(option, idx)
                          }
                          options={this.state.deviceUsedArr}
                          error={pinPutTestDeviceUsedDto.deviceUsedError}
                        />       
                      </Col>                   
                      <Col lg="1">
                        <CgnButton
                          className="dynamicRowDeleteButton"
                          type="button"
                          color="danger"
                          onClick={() => this.handleDeviceUsedRemove(idx)}
                          text={"Sil"}
                        />
                      </Col>
                    </Row>
                  )
                )}

                <Row>
                  <Col lg="4">
                    <CgnButton
                      type="button"
                      color="primary"
                      className="mb-2 dynamicRowAddButton"
                      onClick={this.handleDeviceUsedAdd}
                      text={"Kullanılan Cihaz Ekle"}
                    />
                    {this.state.pinPutTestDeviceUsedError && (
                      <div className="invalid-feedback d-block">
                        {this.state.pinPutTestDeviceUsedError}
                      </div>
                    )}
                  </Col>
                </Row>

                {this.state.pinPutTestProductDto.map(
                  (pinPutTestProductDto, idx) => (
                    <>
                     <Row>
                      <Col className="pl-0">
                      <CgnReactSelect
                          name="productGuid"
                          label="Ürün [*]"
                          placeholder="Ürün seçiniz..."
                          selectValue={pinPutTestProductDto.productGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePinProductSelectChange(option, idx)
                          }
                          options={this.state.productArr}
                          error={pinPutTestProductDto.productError}
                        />       
                      </Col>        
                      <Col>
                      <CgnReactSelect
                          name="materialGuid"
                          label="El Aleti [*]"
                          placeholder="El Aleti seçiniz..."
                          selectValue={pinPutTestProductDto.materialGuid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePinMaterialSelectChange(option, idx)
                          }
                          options={this.state.materialArr}
                          error={pinPutTestProductDto.materialError}
                        />       
                      </Col>    
                      <Col>
                      <CgnReactSelect
                          name="product2Guid"
                          label="Ürün [*]"
                          placeholder="Ürün seçiniz..."
                          selectValue={pinPutTestProductDto.product2Guid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePin2ProductSelectChange(option, idx)
                          }
                          options={this.state.productArr2}
                        />       
                      </Col>        
                      <Col>
                      <CgnReactSelect
                          name="material2Guid"
                          label="El Aleti [*]"
                          placeholder="El Aleti seçiniz..."
                          selectValue={pinPutTestProductDto.material2Guid}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handlePin2MaterialSelectChange(option, idx)
                          }
                          options={this.state.materialArr2}
                          error={pinPutTestProductDto.materialError}
                        />       
                      </Col>   
                    <Col>
                      <CgnTextbox
                      type="text"
                      name="power"
                      label="Uygulanan Güç"
                      value={pinPutTestProductDto.power}
                      placeHolder="Lütfen uygulanan güç girin..."
                      autoComplete="off"
                      onChange={this.handleChange2(idx)}
                    />                                
                      </Col>
                      <Col>
                      <CgnReactSelect
                          name="resultChange"
                          label="Sonuç [*]"
                          placeholder="Sonuç seçiniz..."
                          selectValue={pinPutTestProductDto.resultChange}
                          isMulti={false}
                          isClearable={true}
                          onChange={(option) =>
                            this.handleResultStatusChange(option, idx)
                          }
                          options={manuelControlStatus}
                          error={pinPutTestProductDto.resultChangeError}
                        />       
                      </Col>   
                    </Row>
                    <Row>
                      <Col lg="11" className="pl-0">
                      <CgnTextbox
                      type="text"
                      name="description"
                      label="Açıklama"
                      value={pinPutTestProductDto.description}
                      placeHolder="Lütfen açıklama girin..."
                      autoComplete="off"
                      onChange={this.handleChange2(idx)}
                    />
                      </Col>
                    <Col lg="1">
                        <CgnButton
                          className="dynamicRowDeleteButton"
                          type="button"
                          color="danger"
                          onClick={() => this.handleProductRemove(idx)}
                          text={"Sil"}
                        />
                      </Col>                               
                    </Row>
                    </>

                  )
                )}

                <Row>
                  <Col lg="4">
                    <CgnButton
                      type="button"
                      color="primary"
                      className="mb-2 dynamicRowAddButton"
                      onClick={this.handleProductAdd}
                      text={"İtme Testi Ekle"}
                    />
                    {this.state.pinPutTestProductError && (
                      <div className="invalid-feedback d-block">
                        {this.state.pinPutTestProductError}
                      </div>
                    )}
                  </Col>
                </Row>

                {this.state.alertErrorMessage && (
                  <CgnAlert
                    color="danger"
                    title={CgnMessage.alertErrorTitle}
                    text={this.state.alertErrorMessage}
                  />
                )}
                <CgnButtonGroup items={this.state.buttons} />
              </Card>
            </Form>
            {(this.state.urlSplit[1] === "pin-itme-testi-ekle" ||
              this.state.urlSplit[1] === "pin-itme-testi-guncelle") && (
              <CgnButtonLink
                color="secondary"
                to={"/" + this.state.pageListLink}
                text={CgnMessage.backButton}
                className="btn-back"
              />
            )}
          </Col>
        </Row>
      </>
    );
  }
}

export default withRouter(PinPutTestAddUpdate);
